import { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export interface PrivateBookingIconProps {
  color: string;
}

export const PrivateBookingIcon: FC<PrivateBookingIconProps> = ({ color }) => {
  return (
    <SvgIcon>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.15947 19.4288L12.0002 17.9354L14.8409 19.4288L14.2984 16.2657L16.5965 14.0255L13.4206 13.564L12.0002 10.686L10.5798 13.564L7.40381 14.0255L9.70199 16.2657L9.15947 19.4288ZM11.4358 14.7422L12.0002 13.5987L12.5645 14.7422L13.8264 14.9255L12.9133 15.8156L13.1289 17.0724L12.0002 16.479L10.8715 17.0724L11.0871 15.8156L10.174 14.9256L11.4358 14.7422Z'
          fill={color}
        />
        <path
          d='M19.7281 6.66814C19.55 6.35962 19.6555 5.96586 19.9641 5.78771L20.5222 5.46544L17.9441 1L5.63487 8.10677H1V13.263H1.64453C1.99993 13.263 2.28906 13.5522 2.28906 13.9076V16.4857C2.28906 16.8411 1.99993 17.1302 1.64453 17.1302H1V22.2865H23V17.1302H22.3555C22.0001 17.1302 21.7109 16.8411 21.7109 16.4857V13.9076C21.7109 13.5522 22.0001 13.263 22.3555 13.263H23V8.10677H20.5588L19.7281 6.66814ZM17.4723 2.76086L18.8161 5.08843C18.3086 5.68084 18.183 6.56995 18.6118 7.31267L19.0703 8.10677H8.21295L17.4723 2.76086ZM21.7109 12.0844C20.9607 12.3504 20.4219 13.0673 20.4219 13.9076V16.4857C20.4219 17.326 20.9607 18.0428 21.7109 18.3088V20.9974H2.28906V18.3088C3.03934 18.0428 3.57812 17.326 3.57812 16.4857V13.9076C3.57812 13.0673 3.03934 12.3504 2.28906 12.0844V9.39584H21.7109V12.0844Z'
          fill={color}
        />
      </svg>
    </SvgIcon>
  );
};
